var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaidDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.9455V1.74923C1 1.56503 1.06585 1.38837 1.18306 1.25811C1.30027 1.12786 1.45924 1.05469 1.625 1.05469H15.375C15.5408 1.05469 15.6997 1.12786 15.8169 1.25811C15.9342 1.38837 16 1.56503 16 1.74923V14.9455L13.5 13.5564L11 14.9455L8.5 13.5564L6 14.9455L3.5 13.5564L1 14.9455Z",
    stroke: "#3F3F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90674 7.13333L7.94536 10.172L12.7203 4.96289",
    stroke: "#3F3F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidDollarIcon);
export default __webpack_public_path__ + "static/media/paid-dollar-icon.1ee67f2160a242913e24c8ce07bd6048.svg";
export { ForwardRef as ReactComponent };